import React from "react";

import { ReactComponent as FlowArrow } from "../../../assets/svg/flow_arrow_dual.svg";
import BeforeWorkImg from "../../../assets/images/before_work_sample.png";
import AfterWorkImg from "../../../assets/images/after_work_sample.png";
import TextBookImg from "../../../assets/images/vol1_textbook.png";
import PDFImg from "../../../assets/images/oppa_pdf_sample.png";
import OPPADetailPDF from "../../../assets/pdf/oppa.pdf";
import Modal from "../../../atoms/Modal";
import Button from "../../../atoms/Button";
import StepTitle from "../../../molecules/teacher/StepTitle";

import styles from "./BAWorkGuideModal.module.scss";

type DescriptionCalloutProps = {
  title: string;
  subTitle: string;
  contents: string[];
};
const DescriptionCallout = ({
  title,
  subTitle,
  contents,
}: DescriptionCalloutProps) => {
  return (
    <div className={styles.descriptionCallout}>
      <p className={styles.title}>
        {title}
        <span>{subTitle}</span>
      </p>
      <hr />
      <ul>
        {contents.map(content => (
          <li key={content}>{content}</li>
        ))}
      </ul>
    </div>
  );
};

type Props = {
  onCloseModal: () => void;
};

const BAWorkGuideModal = ({ onCloseModal }: Props) => {
  const handleClickDetail = () => {
    window.open(OPPADetailPDF, "_blank");
  };

  return (
    <Modal
      centered
      onClose={onCloseModal}
      className={styles.contents}
      hasCloseMark
    >
      <div className={styles.contentOne}>
        <StepTitle
          title="Before/After WORKとは？"
          currentStep={1}
          totalStep={2}
          titleStepGap
        />
        <p>
          volの前後で同じ問いに答え、
          <br />
          その変化から
          <span className={styles.annotation}>
            生徒の考えの変化を見とるワーク
          </span>
          です。
        </p>
        <div className={styles.baWorkFlow}>
          <div className={styles.work}>
            <p>Beforeワーク</p>
            <div className={styles.imageWrapper}>
              <img src={BeforeWorkImg} alt="beforeワーク" />
            </div>
          </div>
          <FlowArrow />
          <div className={styles.lesson}>
            <img src={TextBookImg} alt="text book" />
            <p>
              すべての
              <br />
              Lessonを実施
            </p>
          </div>
          <FlowArrow />
          <div className={styles.work}>
            <p>Afterワーク</p>
            <div className={styles.imageWrapper}>
              <img src={AfterWorkImg} alt="afterワーク" />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.contentTwo}>
        <StepTitle
          title="B/A WORKで完成する成果物"
          currentStep={2}
          totalStep={2}
          titleStepGap
        />
        <p>
          学習前後の変化とその過程、生徒自身の振り返りが自動で1枚にまとまり、
          <br />
          <span className={styles.annotation}>
            ポートフォリオや総合・探究の成果物
          </span>
          としてそのまま活用できます。
          <br />
          （PDFでの出力も可能です。［生徒個別］データからダウンロードできます。）
        </p>
        <div className={styles.autoExportPDFImage}>
          <p className={styles.header}>PDF自動出力イメージ</p>
          <div className={styles.sheetContainer}>
            <img src={PDFImg} alt="振り返りシート" />
            <div className={styles.descriptionContainer}>
              <DescriptionCallout
                title="01 授業前後の考えの変化"
                subTitle="(B/A WORKの回答)"
                contents={[
                  "授業前の考え",
                  "授業後の考え",
                  "自分自身の振り返り",
                ]}
              />
              <DescriptionCallout
                title="02 学びのプロセス"
                subTitle="(授業中の振り返り回答)"
                contents={["授業での学び", "その学びをどう活かすか"]}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.buttonArea}>
        <Button
          name="さらに詳しく見る"
          variant="normal"
          className={styles.buttonLayout}
          onClick={handleClickDetail}
        />
        <Button
          name="閉じる"
          variant="normal"
          color="gray"
          className={styles.buttonLayout}
          onClick={onCloseModal}
        />
      </div>
    </Modal>
  );
};

export default BAWorkGuideModal;
